/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PageBootstrapKind {
    PUBLIC = 'Public',
    WORKSPACE = 'Workspace',
    CHANGES = 'Changes',
    PROFILE = 'Profile',
    APPEARANCE = 'Appearance',
    ADMIN_SETTINGS = 'AdminSettings',
    ADMIN_PROJECTS = 'AdminProjects',
    PROJECT_ACCESS = 'ProjectAccess',
    ADMIN_USERS = 'AdminUsers',
    ADMIN_USER = 'AdminUser',
    ADMIN_ROLES = 'AdminRoles',
    MAINTENANCE = 'Maintenance',
}
